import { getRouteApi } from '@mint/routing';

import useFlowData from '../api/queries/useFlowData.js';
import useRolesData from '../api/queries/useRolesData.js';
import useUsersData from '../api/queries/useUsersData.js';
import FlowPageContainer from '../components/FlowPageContainer.jsx';
import FlowPageSkeleton from '../components/skeletons/FlowPageSkeleton.jsx';

const routeApi = getRouteApi('/_secured/company-profile/flows/$flowId/');

const ApprovalPage = () => {
  const { flowId } = routeApi.useParams();
  const {
    data: flowData,
    isPending: isFlowDataPending,
    isError: isFlowDataError,
  } = useFlowData(flowId);
  const { isPending: isUsersPending, isError: isUsersError } = useUsersData();
  const { isPending: isRolesPending, isError: isRolesError } = useRolesData();

  const showLoadingState =
    isFlowDataPending ||
    isFlowDataError ||
    !flowData ||
    isUsersPending ||
    isUsersError ||
    isRolesPending ||
    isRolesError;

  if (showLoadingState) {
    return <FlowPageSkeleton />;
  }

  return <FlowPageContainer flowData={flowData} />;
};

export default ApprovalPage;
